import http from './http'

class Profile {
  fetch () {
    return http.get('/profile')
  }

  permissions () {
    return http.get('profile/permissions')
  }

  dashboard () {
    return http.get('/profile/dashboard')
  }

  save (payload) {
    return http.put('/profile', { user: payload })
  }
}

export default new Profile()



// WEBPACK FOOTER //
// ./src/services/profile.js